import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-stage plan-grid py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-121" data-mp="1iw32ha07833a">
      <div className="mx-auto max-w-6xl px-4" data-id="element-122" data-mp="1dxtb7ahlhmmy">
        <div className="text-center" data-id="element-123" data-mp="2bk8t2ddxomb1">
          <span className="inline-flex items-center gap-2 rounded-md border border-earth/30 bg-earth px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-cream" data-id="element-124" data-mp="2bj7azoyi2zjt">
            <LibraryBigIcon className="h-4 w-4" aria-hidden="true" data-id="element-125" data-mp="21ljh118pxw2p" /> Complete classroom coverage
          </span>
          <h2 id="modules-title" className="mt-4 text-3xl font-extrabold text-forestDeep sm:text-4xl" data-id="element-126" data-mp="1wnrihodkjbpj">
            The {totalVolumes} comprehensive volumes
          </h2>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-127" data-mp="l7b663xb9b6w">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.3,
            delay: index % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col overflow-hidden rounded-xl border border-line bg-white shadow-card" data-id="element-128" data-mp="1ite5chk5dyzc" data-mpi={index}>
                <div className="flex items-center gap-4 border-b-2 border-gold bg-forest px-6 py-5" data-id="element-129" data-mp="14vpij46ishrn">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-gold text-forestDeep" data-id="element-130" data-mp="q7mdbx0axa3w">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-131" data-mp="v65yhv72mhv7" />
                  </span>
                  <div data-id="element-132" data-mp="h76fb32buv6f">
                    <p className="text-[11px] font-extrabold uppercase tracking-[.18em] text-goldBright" data-id="element-133" data-mp="h7zla1tgpgni">
                      Volume {module.number}
                    </p>
                    <h3 className="mt-1 text-lg font-extrabold leading-tight text-cream" data-id="element-134" data-mp="2nvq7c1593pzj">{module.title}</h3>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6" data-id="element-135" data-mp="2e42kkdjn2x4e">
                  <p className="font-semibold text-forestDeep" data-id="element-136" data-mp="2e4lrkz7r413n">{module.subtitle}</p>

                  <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[.16em] text-earth" data-id="element-137" data-mp="296u2ecyhqt35">
                    What does it solve in the classroom?
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-inkSoft" data-id="element-138" data-mp="31uybl8g9toal">{module.context}</p>

                  <ul className="mt-5 grid flex-1 gap-2" data-id="element-139" data-mp="2wtsg52v87mxd">
                    {module.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-ink" data-id="element-140" data-mp="2ssglgixhwbib">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forestMid" aria-hidden="true" data-id="element-141" data-mp="1lgpw1xtx4f8g" />
                        {item}
                      </li>)}
                  </ul>

                  <p className="mt-6 rounded-lg border-l-4 border-gold bg-beige p-4 text-sm leading-relaxed text-ink" data-id="element-142" data-mp="3t2pz8o88vfzk">
                    <b className="font-extrabold text-forestDeep" data-id="element-143" data-mp="xw0f41jkt04">Result: </b>
                    {module.result}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl border-2 border-forest bg-white px-6 py-6 text-center shadow-card sm:flex-row sm:text-left" data-id="element-144" data-mp="fmilznhrigzs">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-earth" data-id="element-145" data-mp="knpslj865a4v">Main collection</p>
          <p className="font-display text-2xl font-extrabold text-forestDeep sm:text-3xl" data-id="element-146" data-mp="oldvb8g3s77b">
            {totalVolumes} premium volumes <span className="mx-2 text-gold" data-id="element-147" data-mp="2qetnwavr3w4x">·</span> Updated for 2026
          </p>
        </div>
      </div>
    </section>;
}